import { DateFilter } from '../hooks/useDateFilter';
import { DateUtils } from './DateUtils';

export enum DatePickerErrors {
  TO_DATE_BEFORE_FROM_DATE = 'Fra dato kan ikke være større enn til dato!',
  FROM_DATE_BIGGER_THAN_TOMORROW = 'Fra dato kan ikke være større enn i dag!',
  SET_FROM_AND_TO_DATE = 'Velg fra og til dato!',
}

export type validateDatePickerFormData = string;

type validateDatePickerFormReturn = {
  hasError: boolean;
  data: validateDatePickerFormData;
};

export class ValidationUtils {
  public static validateDatePickerForm(
    dates: DateFilter,
  ): validateDatePickerFormReturn {
    if (!dates.fromDate || !dates.toDate) {
      return {
        hasError: true,
        data: DatePickerErrors.SET_FROM_AND_TO_DATE,
      };
    }

    const today: Date = new Date();
    const tomorrow: string = DateUtils.addDaysToTargetDate(today, 1);
    if (dates.fromDate >= tomorrow) {
      return {
        hasError: true,
        data: DatePickerErrors.FROM_DATE_BIGGER_THAN_TOMORROW,
      };
    }

    if (
      ValidationUtils.verifyFromDateIsBeforeToDate(dates.fromDate, dates.toDate)
    ) {
      return {
        hasError: true,
        data: DatePickerErrors.TO_DATE_BEFORE_FROM_DATE,
      };
    }

    return {
      hasError: false,
      data: '',
    };
  }

  private static verifyFromDateIsBeforeToDate(
    fromDate: string,
    toDate: string,
  ): boolean {
    const fromDateAsDate: Date = new Date(fromDate);
    const toDateAsDate: Date = new Date(toDate);
    return fromDateAsDate > toDateAsDate;
  }
}
